import { render, staticRenderFns } from "./AppEventSliderItem.vue?vue&type=template&id=48e39938&scoped=true&"
import script from "./AppEventSliderItem.vue?vue&type=script&lang=js&"
export * from "./AppEventSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./AppEventSliderItem.vue?vue&type=style&index=0&id=48e39938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e39938",
  null
  
)

export default component.exports